import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import RadioGroup from '../RadioGroup'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * If exists, calls it with the value for custom additional actions
   * Formik setFieldValue will always run before it
   */
  onChange: PropTypes.func,
}

/**
 * Connects the RadioGroup with Formik.
 */
function FormikRadioGroup(props) {
  const { id, onChange = null } = props ?? {}

  return (
    <Field name={id}>
      {({ field, meta, form }) => (
        <RadioGroup
          {...props}
          id={id}
          onChange={(value) => {
            form.setFieldValue(id, value)
            if (onChange) {
              onChange(value)
            }
          }}
          onBlur={() => {
            form.setFieldTouched(id, true) // set the touched flag (important for displaying errors)
          }}
          value={field.value}
          errors={meta.touched && meta.error ? [meta.error] : []}
        />
      )}
    </Field>
  )
}

FormikRadioGroup.propTypes = propTypes

export default FormikRadioGroup
